export const ENV = process.env.NEXT_PUBLIC_ENV;

export const BASE_API_AUTH = process.env.NEXT_PUBLIC_AUTH_SERVICE;

export const BASE_API_QUESTION_BUILDER =
  process.env.NEXT_PUBLIC_QUESTION_BUILDER;

export const BASE_API_DASHBOARD = process.env.NEXT_PUBLIC_ANALYSIS_SERVICE;

export const BASE_API_PAYMENTS = process.env.NEXT_PUBLIC_PAYMENT_SERVICE;

export const BASE_API_PLAYGROUND = process.env.NEXT_PUBLIC_PLAYGROUND_SERVICE;

export const passwordValidations = [
  'Should have atleast 10 letters',
  'Should have a number',
  'Should have an uppercase character',
  'Should have a special character',
  'Should have a lowercase character',
];

export const sortByData = [
  { id: 'createdDate', text: 'Created Date' },
  { id: 'title', text: 'Title' },
  { id: 'respondent', text: 'Responses' },
  { id: 'updatedDate', text: 'Updated Date' },
];

export const orderByData = [
  { id: 'desc', text: 'Descending' },
  { id: 'asc', text: 'Ascending' },
];

export const statusData = [
  { id: 'done', text: 'Done' },
  { id: 'rejected', text: 'Rejected' },
];

export const languagesList = [
  { id: 'ar', title: 'Arabic' },
  { id: 'id', title: 'Bahasa (Indonesian)' },
  { id: 'ben', title: 'Bengali (India)' },
  { id: 'zh', title: 'Chinese, Mandarin' },
  { id: 'zh_hant', title: 'Chinese, Traditional' },
  { id: 'cs', title: 'Czech (Czech Republic)' },
  { id: 'da', title: 'Danish (Denmark)' },
  { id: 'en', title: 'English (United States)' },
  { id: 'fr', title: 'French (France)' },
  { id: 'de', title: 'German (Germany)' },
  { id: 'gu', title: 'Gujarati (India)' },
  { id: 'hi', title: 'Hindi (India)' },
  { id: 'it', title: 'Italian (Italy)' },
  { id: 'ja', title: 'Japanese (Japan)' },
  { id: 'kn', title: 'Kannada (India)' },
  { id: 'ko', title: 'Korean' },
  { id: 'ms', title: 'Malay (Malaysia)' },
  { id: 'ml', title: 'Malayalam (India)' },
  { id: 'mr', title: 'Marathi (India)' },
  { id: 'pl', title: 'Polish (Poland)' },
  { id: 'pt', title: 'Portuguese (Brazil)' },
  { id: 'es', title: 'Spanish (Spain)' },
  { id: 'tl', title: 'Tagalog/Filipino (Philippines)' },
  { id: 'ta', title: 'Tamil (India)' },
  { id: 'te', title: 'Telugu (India)' },
  { id: 'th', title: 'Thai (Thailand)' },
  { id: 'tr', title: 'Turkish (Turkey)' },
  { id: 'vi', title: 'Vietnamese' },
];

export const TRANSCRIPT_LANGUAGES = [
  { id: '--', text: 'Multiple Languages (Select during each interview upload)' },
  { id: 'en', text: 'American English' },
  { id: 'ar', text: 'Arabic' },
  { id: 'en_au', text: 'Australian English' },
  { id: 'bn', text: 'Bengali' },
  { id: 'en_uk', text: 'British English' },
  { id: 'zh', text: 'Chinese (Mandarin)' },
  { id: 'nl', text: 'Dutch' },
  { id: 'fr', text: 'French' },
  { id: 'de', text: 'German' },
  { id: 'el', text: 'Greek' },
  { id: 'gu', text: 'Gujarati' },
  { id: 'hi', text: 'Hindi' },
  { id: 'id', text: 'Indonesian' },
  { id: 'it', text: 'Italian' },
  { id: 'ja', text: 'Japanese' },
  { id: 'kn', text: 'Kannada' },
  { id: 'ko', text: 'Korean' },
  { id: 'ms', text: 'Malay' },
  { id: 'mr', text: 'Marathi' },
  { id: 'pl', text: 'Polish' },
  { id: 'pt', text: 'Portuguese' },
  { id: 'pa', text: 'Punjabi' },
  { id: 'ru', text: 'Russian' },
  { id: 'es', text: 'Spanish' },
  { id: 'tl', text: 'Tagalog/Filipino' },
  { id: 'ta', text: 'Tamil' },
  { id: 'te', text: 'Telugu' },
  { id: 'th', text: 'Thai' },
  { id: 'tr', text: 'Turkish' },
  { id: 'uk', text: 'Ukrainian' },
  { id: 'vi', text: 'Vietnamese' },
  { id: '-', text: 'Automatic Detection (System will detect language)' },
];

export const ENGLISH_LANGUAGES = [
  { id: 'en', text: 'American English' },
  { id: 'en_uk', text: 'British English' },
  { id: 'en_au', text: 'Australian English' },
];

export const TRANSLATE_LANGUAGES = TRANSCRIPT_LANGUAGES;

export const AnalysislanguagesList = [
  { id: 'en', text: 'English (United States)' },
  { id: 'manual', text: 'Manual Transcript' },
];

export const PAGINATION_LIMIT = 10;

export const roleData = [
  { id: 'Brand', text: 'Brand' },
  { id: 'Transcript_vendor', text: 'Transcript Vendor' },
  { id: 'Data_vendor_with_transcript', text: 'Data Vendor With Transcript' },
  {
    id: 'Data_vendor_with_out_transcript ',
    text: 'Data Vendor Without Transcript',
  },
  { id: 'Data_qc_vendor', text: 'Data QC vendor' },
  { id: 'Owner', text: 'Owner' },

  { id: 'Research_associate', text: 'Research Associate' },
  { id: 'Client', text: 'Client' },
  {
    id: 'Client_with_out_personal_info',
    text: 'Client Without Personal Info - hide video',
  },
  {
    id: 'Client_analysis_only_with_out_pip',
    text: 'Client Without Personal Info - show video',
  },
  { id: 'Data_viewer_only_approved', text: 'Data viewer only approved' },
  { id: 'Data_viewer', text: 'Data viewer' },
  {
    id: 'Data_viewer_hide_pip',
    text: 'Data viewer only approved Without Personal Info',
  },
];

export const operationDropDown = [
  { id: 'OP-Reject', text: 'Reject' },
  { id: 'OP-Done', text: 'Approve' },
];

// Approval cell dropdown. 'Pending' clears the decision: the backend maps it to
// NULL, which is what the column filter looks for (`s_u.status isnull`) and how
// an unreviewed row has always been stored. Without it a reviewer who approved
// or rejected by mistake had no way back.
export const enumerateDropDown = [
  { id: 'Done', text: 'Approve' },
  { id: 'Pending', text: 'Pending' },
  { id: 'Reject', text: 'Reject' },
];

export const operationDropDownHeader = [
  { id: 'OP-Reject', text: 'Reject' },
  { id: 'Pending', text: 'Pending' },
  { id: 'OP-Done', text: 'Approve' },
];
export const enumerateDropDownHeader = [
  { id: 'Done', text: 'Approve' },
  { id: 'Pending', text: 'Pending' },
  { id: 'Reject', text: 'Reject' },
];

export const rejectReasonDropDown = [
  { id: '0', text: 'Profile SEC mismatch - wrong SEC selected' },
  { id: '1', text: 'Profile SEC mismatch - CWE Education code' },
  { id: '2', text: 'Profile SEC mismatch - CWE Occupation code' },
  { id: '3', text: 'Profile Age mismatch' },
  { id: '4', text: 'Profile Location mismatch' },
  { id: '5', text: 'Profile Gender mismatch' },
  { id: '6', text: 'Profile - Respondent not correct' },
  { id: '7', text: 'No video captured' },
  { id: '8', text: 'Video - junk upload' },
  { id: '9', text: 'Video -  No voice' },
  { id: '10', text: 'Video - No face' },
  { id: '11', text: 'Video - irrelevant video background' },
  { id: '12', text: 'Video - same video for all question' },
  { id: '13', text: 'Audio - no audio' },
  { id: '14', text: 'Audio - audio not good / clear' },
  { id: '15', text: 'Audio - audio with irrelevant answer' },
  { id: '16', text: 'Audio - audio with multiple voice' },
  { id: '17', text: 'Audio - audio with lot of noise' },
  { id: '18', text: 'Audio - audio with lot of disturbances' },
  { id: '19', text: 'Irrelevant answer' },
  { id: '20', text: 'Bad answer' },
  { id: '21', text: 'Response is scripted' },
  { id: '22', text: 'Response is prompted' },
  { id: '23', text: 'Fraud - Duplicate respondent (same person twice)' },
  { id: '24', text: 'Fraud - Shared device' },
  { id: '25', text: 'Fraud - Shared internet address' },
  { id: '26', text: 'Speeder - completed too fast' },
  { id: '27', text: 'Straightlining - same answer throughout' },
  { id: '28', text: 'Contradictory answers' },
  { id: '29', text: 'Failed attention check' },
  { id: '30', text: 'Copied answer - same as another respondent' },
  { id: '31', text: 'AI-generated answer' },
  { id: '32', text: 'Photo - reused / same photo for all questions' },
  { id: '33', text: 'Photo - junk / irrelevant upload' },
  { id: '34', text: 'Impossible or out-of-range values' },
  { id: '35', text: 'Routing - answered questions they should have skipped' },
];

export const returnFilterTypeReportElement = (answerType: any) => {
  switch (answerType) {
    case 'matrix':
    case 'summary':
    case 'theme':
    case 'theme_multiple':
    case 'sentiment':
    case 'heatmap':
    case 'theme_cloud':
      return answerType;

    default:
      return 'question';
  }
};
export const SEPARATOR = '#SEP#';

// this will keep the slider function smooth
export const MOD = 10 * 100 * 100;

export const SIGN_UP_USER_TYPES = [
  { id: 'all', text: 'All' },
  { id: 'EY', text: 'EY' },
  { id: 'USA', text: 'USA' },
  { id: 'niq_usa', text: 'NIQ USA' },
];
